import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';
import { ROLES } from '../utils/constants';
import { AddUpdateSignerFormData } from '../components/LanguageInterpreters/AddInterpreter';

interface GetAllSignersParams {
  page: number;
  pageSize: number;
  searchData: {
    roles: string[],
    searchTerm: string
  }
};

interface GetAllGuidesResponse {
  count: number;
  rows: [];
};

interface CommonResponse {
  data:{}
};

class SignerAPI {

    async getAllSigners(params: GetAllSignersParams): Promise<GetAllGuidesResponse> {
        const jwt = localStorage.getItem('access-token')
        const offset = params.page * params.pageSize;
        const limit = params.pageSize;
        const roleName = [ROLES.SIGN_INTERPRETER];
        const searchTerm = params?.searchData?.searchTerm || "";
        const res: AxiosResponse = await makeAPIRequest({
          method: 'GET',
          url: `/api/users?offset=${offset}&limit=${limit}&roleName=${roleName}&name=${searchTerm}`,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data.data
    };

    async getAllSignersForFilter(): Promise<GetAllGuidesResponse> {
        const jwt = localStorage.getItem('access-token')
        const queryParams = new URLSearchParams({
          roleName: ROLES.SIGN_INTERPRETER,
          enabled: "true"
        });
        const res: AxiosResponse = await makeAPIRequest({
          method: 'GET',
          url: `/api/users/filter?${queryParams}`,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data.data
    };

    async createSigner(data: AddUpdateSignerFormData): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'POST',
          url: `/api/users/invite`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

    async updateSigner(userId: string, data: AddUpdateSignerFormData): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'PUT',
          url: `/api/users/${userId}`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

    async enabledDisabledSigner(userId: string, data: {enabled: boolean}): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'PUT',
          url: `/api/users/${userId}/activateOrDeactivateAccount`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

}

const signerApi = new SignerAPI();
export default signerApi;